export type AnalyticsInterval = "week" | "day" | "hour" | "minute";

// Both charts use the same bucket precision and the API's reporting timezone.
export function formatAnalyticsTimestamp(
  value: string,
  interval: AnalyticsInterval,
  timezone: string,
  context: "axis" | "tooltip" = "axis",
): string {
  const options: Intl.DateTimeFormatOptions = { timeZone: timezone };
  if (interval !== "minute" || context === "tooltip") {
    options.month = "short";
    options.day = "numeric";
  }
  if (context === "tooltip") options.year = "numeric";
  if (interval === "hour" || interval === "minute") {
    options.hour = "2-digit";
    options.minute = "2-digit";
    options.hourCycle = "h23";
    if (context === "tooltip") options.timeZoneName = "short";
  }
  const label = new Date(value).toLocaleString("en-US", options);
  return interval === "week" ? `Week of ${label}` : label;
}
